export const Align = {
    LEFT: 'left',
    RIGHT: 'right',
}

export const NEW_RECORD = 'NUEVO'

export const LOADING = 'Cargando ...'

